/* eslint-disable prettier/prettier */
import React from "react";
import PropTypes from "prop-types";
import MDBox from "admin/components/MDBox";
import MDTypography from "admin/components/MDTypography";
import MDButton from "admin/components/MDButton";
import Icon from "@mui/material/Icon";
import Modal from "@mui/material/Modal";
import Card from "@mui/material/Card";

function CSVConfirmationModal({ open, onClose, onConfirm, eventCount, errorCount }) {
    return (
        <Modal open={open} onClose={onClose}>
            <MDBox
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    bgcolor: "background.paper",
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 4,
                    outline: "none",
                }}
            >
                <Card sx={{ boxShadow: "none" }}>
                    <MDBox display="flex" flexDirection="column" alignItems="center" textAlign="center">
                        <MDTypography variant="h5" fontWeight="medium" mb={2}>
                            Import events (CSV)
                        </MDTypography>

                        <MDTypography variant="body2" color="text" mb={1}>
                            The CSV you’ve uploaded contains <strong>{eventCount}</strong> events
                        </MDTypography>

                        <MDBox display="flex" alignItems="center" gap={1} mb={3}>
                            <Icon color={errorCount > 0 ? "error" : "success"}>
                                {errorCount > 0 ? "warning" : "check_circle"}
                            </Icon>
                            <MDTypography
                                variant="body2"
                                fontWeight="medium"
                                color={errorCount > 0 ? "error" : "success"}
                            >
                                {errorCount} anomaly/error detected
                            </MDTypography>
                        </MDBox>

                        <MDBox display="flex" gap={2} width="100%" justifyContent="center">
                            <MDButton
                                variant="gradient"
                                color="info"
                                onClick={onConfirm}
                                disabled={errorCount > 0} // Optional: disable if errors exist
                            >
                                Confirm import
                            </MDButton>
                            <MDButton variant="outlined" color="secondary" onClick={onClose}>
                                Cancel
                            </MDButton>
                        </MDBox>
                    </MDBox>
                </Card>
            </MDBox>
        </Modal>
    );
}

CSVConfirmationModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    eventCount: PropTypes.number.isRequired,
    errorCount: PropTypes.number.isRequired,
};

export default CSVConfirmationModal;
